import { motion } from 'motion/react'
import Image from 'next/image'
import type { ComponentProps } from 'react'
import { cn } from '@/src/utils/styles'

export const DEFAULT_AVATAR = 'alice'

const AVATARS = [
  'alice',
  'bob',
  'bull',
  'charlie',
  'dorothy',
  'eric',
  'mongoose',
  'owl',
  'rabbit',
  'whale',
  'cloud-man',
] as const

export type Avatar = (typeof AVATARS)[number]

// Export the AVATARS array for use in other components
export { AVATARS }

const MotionImage = motion.create(Image)

interface AvatarImageProps
  extends Omit<
    ComponentProps<typeof MotionImage>,
    'src' | 'alt' | 'width' | 'height' | 'className' | 'layoutId'
  > {
  avatar: Avatar
  size?: number
  className?: string
  layoutId?: string
}

export const AvatarImage = ({
  avatar,
  size = 32,
  className,
  layoutId,
  ...props
}: AvatarImageProps) => (
  <MotionImage
    src={getAvatarImage(avatar)}
    alt={avatar}
    width={size}
    height={size}
    className={cn('rounded-full', className)}
    layoutId={layoutId}
    {...props}
  />
)

function getAvatarImage(avatar: Avatar) {
  return `/avatars/${avatar}.png`
}
